import React, { useEffect, useState } from "react";
import api from 'api';
import { API } from "common/config-api"; // jsconfig.json

const UserMemoRow = ({memo}) => {
  //console.log(memo);
  return (
  <tr>
    <td>
      {memo.userMemoContent}
      <br />
      <code>{memo.userMemoDate}</code>
    </td>
  </tr>
  );
}


const UserTabMemo = ({idx}) => {

  const apiUrl = `${API.BASE_URL}`;

  console.log("userTabMemoidx: ", idx);

  const [memo, setMemo] = useState({
    userIdx: idx,
    userMemoContent: ""
  });
  const [userMemoList, setUserMemoList] = useState([]);

  const setMemoContent = (event) => {
    const { value, name } = event.target;
    //setMemo({...memo, [name]: value});
    setMemo({userIdx: idx, [name]: value});
  }

  const submitMemo = async () => {
    console.log("memo.userIdx: ", memo);
    try {
      const response = await api.post(apiUrl + '/user/memo/' + idx, memo);
      const resp = response;
      setTimeout(getUserMemo, 1000);
    } catch (error) {
      console.error('메모 등록 실패:', error);
      alert('메모 등록 중 오류가 발생했습니다.');
    }
  }

  const getUserMemo = async () => {
    console.log("userMemoApiUrl: ", apiUrl + '/user/memo/' + idx);
    try {
      const response = await api.get(apiUrl + '/user/memo/' + idx);
      const resp = response;
      console.log("memoResp", resp);
      setUserMemoList(resp);
    } catch (error) {
      console.error('메모 조회 실패:', error);
      alert('메모 조회 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    getUserMemo();
  }, []);

  return(
    <>
    <textarea className="form-control" style={{height:"100px"}} name="userMemoContent" onChange={setMemoContent} defaultValue={''}>
    </textarea>
    <button type="button" onClick={submitMemo} className="btn btn-primary">등록/수정</button>

    <table className="table table-hover">
    <tbody>
    {userMemoList.length === 0 ? <tr><td>입력된 내용이 없습니다.</td></tr> : userMemoList.map((data, idx) => ( <UserMemoRow key={idx} memo={data} /> ))}
    </tbody>
    </table>
    </>
  );
}

export default UserTabMemo;




